export default __webpack_public_path__ + "static/media/init-state.fe571e47.svg";